<template>
    <form-wrapper @form-submit="submit">
        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.auth.login.fields.email.label')"
                    :placeholder="$t('forms.auth.login.fields.email.placeholder')"
                    :isRequired="true"
                    type="email"
                    name="email"
                    valuePath="email"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <div class="password-container">
                    <p class="forgot-password" @click="forgotPassword()">
                        {{ $t('forms.auth.login.links.forgot_password') }}
                    </p>
                    <text-input
                        :formData="data"
                        :label="$t('forms.auth.login.fields.password.label')"
                        :placeholder="$t('forms.auth.login.fields.password.placeholder')"
                        :isRequired="true"
                        type="password"
                        name="password"
                        valuePath="password"
                        @change="change"
                    ></text-input>
                </div>
            </form-cell>
        </form-row>

        <template #footer>
            <common-button :isProcessing="isLoading" type="primary" :label="$t('forms.auth.login.buttons.login')"></common-button>
        </template>
    </form-wrapper>
</template>

<script>
    import AuthAPI from 'api/AuthAPI'
    import FormMixin from 'mixins/FormMixin'
    import LoginType from 'enums/login_type.enum'
    import RoutesEnum from 'enums/routes.enum'

    export default {
        mixins: [FormMixin],

        data: () => ({ RoutesEnum }),

        methods: {
            resendVerificationEmail() {
                AuthAPI.resendVerificationEmail({ email: this.data.email })
                    .then(() => {
                        this.emitEvent({
                            name: 'verificationEmailSent',
                        })
                    })
                    .catch(() => {})
            },
            forgotPassword() {
                this.$router.push({ name: RoutesEnum.AUTH.FORGOT_PASSWORD })
            },
            submit() {
                this.submitForm(AuthAPI.login(this.data))
                    .then((res) => {
                        this.$auth.createSession({
                            accessToken: res.payload.access_token,
                            refreshToken: res.payload.refresh_token,
                            loginType: LoginType.BASIC,
                        })
                        if (this.$route.query.redirect?.length) {
                            window.location.href = `/#${this.$route.query.redirect}`
                            return
                        }
                        if (localStorage.getItem('redirect')) {
                            window.location.href = `/#${localStorage.getItem('redirect')}`
                            localStorage.removeItem('redirect')
                            return
                        }
                        if (this.$auth.isSubdomainActive()) {
                            this.$router.push({ name: RoutesEnum.SUBDOMAIN.COMPANY })
                        } else {
                            this.$router.push({ name: RoutesEnum.INDEX.HOME })
                        }
                    })
                    .catch((e) => {
                        this.emitEvent({
                            name: 'failure',
                            payload: {
                                errorMessage: e.error.message,
                                email: this.data.email,
                                callbackResendVerificationEmailFunction: this.resendVerificationEmail,
                            },
                        })
                    })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';

    .password-container {
        position: relative;
    }
    .forgot-password {
        position: absolute;
        right: 0;
        text-transform: none;
        font-weight: unset;
        font-size: 16px;
        height: fit-content;
        padding: 0;
        color: $color-link;
        cursor: pointer;

        &:hover {
            opacity: 0.8;
        }
    }
</style>
